<template>
    <div
        class="chat-assistent-interaction-item"
    >
        <div class="chat-assistent-interaction-item__content">
            <div
                v-for="(message, index) in innerMessages"
                :key="index"
                v-html="message"
            />
        </div>
        <div class="chat-assistent-interaction-item__avatar">
            <assistent-avatar :assistent="props.assistent" />
        </div>
        <div class="chat-assistent-interaction-item__footer">
            <text-decorator :size="FontSize.xs">
                {{ formatTime(interaction.createdAt) }}
            </text-decorator>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { Assistent, Interaction } from '@keyvue/one-api-client';
    import { marked } from 'marked';
    import { computed } from 'vue';
    import { formatTime } from '@/shared/utils/date';
    import { FontSize } from '@keyvue/one-ui';
    import AssistentAvatar from '@/ai/assistent/components/AssistentAvatar.vue';

    const props = defineProps<{
        interaction: Interaction,
        assistent: Assistent,
    }>();

    const innerMessages = computed(() => {
        const messages = props.interaction.content
            .split('\n\n')
            .map((value) => marked(
                value.replace(/【[^】]+】/g, ''),
            ));

        return messages;
    });

</script>

<style scoped lang="scss">
    .chat-assistent-interaction-item {
        max-width: 80%;
        display: flex;
        align-self: flex-end;
        align-items: flex-end;
        justify-content: flex-end;
        flex-wrap: wrap;

        &__avatar {
            width: size(lg);
            height: size(lg);
            padding: 0 size(sm);
        }

        &__content {
            width: calc(100% - 50px);
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            flex-wrap: wrap;
            gap: size(sm);

            & > div {
                padding: size(md);
                border-radius: size(sm);
                box-sizing: border-box;
                background-color: #DDE8F7;
                color: var(--theme-colors-default--gray-700);
                border-bottom: 1px solid var(--theme-colors-default--gray-300);
                box-shadow: 0 0 5px 0 rgba(0,0,0,0.15);
                font-size: font-size(sm);
                line-height: 19px;

                :deep(img) {
                    max-width: 100%;
                    height: auto;
                    margin: .5rem 0;
                }
            }
        }

        &__footer {
            padding-top: 5px;
            padding-right: 50px;
        }
    }
</style>
